import React, { Fragment, useState, useEffect } from 'react';
import { Button, Dialog } from '@material-ui/core';
import SlidePanel from 'Components/SlidePanel/SlidePanel';
import useTranslation from '../../../Hooks/useTranslation';
import UnitList from './UnitList';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useBoxes } from '../../../Contexts/BoxContext';
import UnitTemplateList from './UnitTemplateList';

const LoadUnitTemplateModal = (props) => {

    const {
        isOpen,
        onCancel,
        onTemplateLoad,
        dontShowChangeUnitModal,
        licensesNames
    } = props;

    const {
        currentUnitModel,
        currentUnitTitle,
        setCurrentUnit,
        unitsRequest,
        unitBoxes,
    } = useBoxes();

    const translation = useTranslation();
    const [isSelectUnitStep, setIsSelectUnitStep] = useState(true);
    const [templateLoadedResponse, setTemplateLoadedResponse] = useState({ tabs: null, template: null });
    const [errors, setErrors] = useState({
        type: 'error', //warning
        messages: null,
    });

    const { data: units } = unitsRequest;

    useEffect(() => {
        if (currentUnitTitle && !dontShowChangeUnitModal) {
            setIsSelectUnitStep(false);
        }
    }, [currentUnitTitle, dontShowChangeUnitModal]);

    const handleBack = () => setIsSelectUnitStep(true);

    const handleSaveUnit = (unitId) => {
        setIsSelectUnitStep(false);
        setCurrentUnit(unitId);
    };

    const renderTitle = () => isSelectUnitStep && !dontShowChangeUnitModal
        ? (translation.headerUnitsLabel || 'Units')
        : currentUnitTitle;

    const renderBackToUnitButton = () => {
        if (unitBoxes.length) return null;
        if (isSelectUnitStep) return null;

        return (
            <IconButton aria-label="back" size="small" onClick={handleBack}>
                <ArrowBackIcon fontSize="inherit" />
            </IconButton>
        );
    };

    const renderUnitList = () => {
        if (!isSelectUnitStep || dontShowChangeUnitModal) return;

        return (
            <UnitList
                items={units}
                onCancel={onCancel}
                onSave={handleSaveUnit}
                isTemplate
                licensesNames={licensesNames}
            />
        );
    };

    const handleErrorTemplateLoad = ({ errors, response }) => {
        setErrors(errors);
        setTemplateLoadedResponse(response);
    };

    const renderTemplateList = () => {
        if (isSelectUnitStep && !dontShowChangeUnitModal) return;

        return (
            <UnitTemplateList
                unit={currentUnitModel}
                onCancel={() => {
                    setIsSelectUnitStep(true);
                    onCancel();
                }}
                onSuccessTemplateLoad={handleSuccessTemplateLoad}
                onErrorTemplateLoad={handleErrorTemplateLoad}
            />
        );
    };

    const handleSuccessTemplateLoad = (tabs, template) => {
        onTemplateLoad(tabs, template)
        // onTemplateLoaded(selectedTemplate, selectedJob, tabs, template);
        // isOpenChangeHandler(false);
    };

    const handleErrors = () => {
        setErrors({ type: 'error', messages: null });
        if (errors.type === 'warning') {
            const { tabs, template } = templateLoadedResponse;
            if (tabs && template) {
                handleSuccessTemplateLoad(tabs, template);
            }
        }
    };

    const renderErrorDialog = () => {
        const title = errors.type === 'error' ? 'Error' : 'Warning';
        const iconClass = errors.type === 'error'
            ? 'modalTitle hasIcon error'
            : 'modalTitle hasIcon warning';
        return (
            <Dialog open={Boolean(errors.messages)}>
                <div className="modalTitleHolder mb16">
                    <h2 className={iconClass}>{title}</h2>
                </div>
                <ul className="errorList">
                    {
                        errors.messages && errors.messages.map((errorMessage, index) => (
                            <li key={index}>{errorMessage}</li>))
                    }
                </ul>
                <div className="btnHolder end mt22 fixedWidthBtn">
                    <Button color={'primary'}
                            onClick={handleErrors}
                            variant={'contained'}>
                        Ok
                    </Button>
                </div>
            </Dialog>
        );
    };

    const backButton = renderBackToUnitButton();

    return (
        <Fragment>
            <SlidePanel
                open={isOpen}
                onClose={onCancel}
                title={renderTitle()}
                headerStart={backButton ? <div className="backLinkHolder">{backButton}</div> : null}
                className={isSelectUnitStep && !dontShowChangeUnitModal ? 'appSlidePanel--wide' : ''}
            >
                {renderUnitList()}
                {renderTemplateList()}
            </SlidePanel>
            {renderErrorDialog()}
        </Fragment>
    );
};

export default LoadUnitTemplateModal;
